import {
  CardAttributeUpdateAction,
  CardAttributeUpdateActionsEnum,
  computeInverseCardAttributeUpdateAction,
} from '../../../../helpers/models/cardAttributeUpdateHelpers';
import {CardNoteUpdateAction, CardNoteUpdateActionsEnum} from '../../../../helpers/models/cardNoteHelpers';
import {ThunkAsyncAction} from '../../../appThunk';
import {
  deleteCardNoteAsyncAction,
  undeleteCardNoteAsyncAction,
  updateCardNoteAsyncAction,
} from '../../../data/cardNotes/cardNotesActions';
import {updateCardAttributeAsyncAction} from '../../../data/cards/cardsActions';
import {getCards} from '../../../data/dataSelectors';
import {AppPanelId} from '../../panelStateBase';
import {removeBannerAction} from './bannersActions';
import {ContactDetailsUndoBannerState} from './bannersState';

/*
 * Types.
 */

export type ContactDetailsUndoBannerAction = CardAttributeUpdateAction | CardNoteUpdateAction;

/*
 * Actions.
 */

export function undoContactDetailsBannerAction(
  panelId: AppPanelId,
  banner: ContactDetailsUndoBannerState,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const card = getCards(getState())[banner.cardId];
    if (!card) {
      return;
    }

    const action = banner.action as ContactDetailsUndoBannerAction;

    if (checkActionIsCardAttributeUpdateAction(action)) {
      const inverseAction = computeInverseCardAttributeUpdateAction(action);
      dispatch(
        updateCardAttributeAsyncAction({
          panelId: banner.panelId,
          card,
          action: inverseAction,
          shouldShowUndoBanner: false,
        }),
      );
    }

    if (checkActionIsCardNoteUpdateAction(action)) {
      const asyncAction = computeInverseCardNoteAsyncAction(action);
      if (asyncAction) {
        dispatch(asyncAction);
      }
    }

    // Hide the banner from the UI.
    dispatch(removeBannerAction(panelId, banner.uid));
  };
}

/*
 * Helpers.
 */

function checkActionIsCardAttributeUpdateAction(
  action: ContactDetailsUndoBannerAction,
): action is CardAttributeUpdateAction {
  return action.type in CardAttributeUpdateActionsEnum;
}

function checkActionIsCardNoteUpdateAction(
  action: ContactDetailsUndoBannerAction,
): action is CardNoteUpdateAction {
  return action.type in CardNoteUpdateActionsEnum;
}

function computeInverseCardNoteAsyncAction(action: CardNoteUpdateAction) {
  if (action.type === CardNoteUpdateActionsEnum.CREATE_NOTE) {
    return deleteCardNoteAsyncAction(action.payload.note);
  }

  if (action.type === CardNoteUpdateActionsEnum.DELETE_NOTE) {
    return undeleteCardNoteAsyncAction(action.payload.note);
  }

  if (action.type === CardNoteUpdateActionsEnum.UPDATE_NOTE) {
    return updateCardNoteAsyncAction(action.payload.newNote, action.payload.currentNote);
  }

  return null;
}
